<template>
  <div class="box">
    <b-container fluid>
            <b-row class="justify-content-md-center">
        <b-col xl="4" v-if="!isMobile" lg="4" md="4" sm="10" class="pc-left-title">
          <h4 class="mt-2 mt-title">Choose Category:</h4>
        </b-col>
        <b-col xl="6" v-if="!isMobile" lg="6" md="6" sm="10" class="pc-right-select">
          <m-demo-all-check />
        </b-col>
        <b-col xl="6" v-if="isMobile" lg="6" md="10" sm="10" class="mb-right-select">
          <m-demo-all-check />
        </b-col>
        <b-col xl="4" v-if="isMobile" lg="4" md="10" sm="10" class="mb-left-title">
          <h4 class="mt-2 mt-title">Choose Category:</h4>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col align-self="center" xl="10" lg="10" md="10" sm="12">
          <div class="card state-box">
            <m-demo-select-type
              v-if="needDemo"
              v-for="item in categories"
              :category="item"
              :specialDemoCategory="specialDemoCategory"
              :key="item.demoType"
            />
            <m-loader size="before" :show="!hasLoad" />
            <m-demo-select-item
              v-if="!needDemo"
              v-for="item in columns"
              :item="item"
              :disabled="item.AttributeValue === 'DoNotChooseThis'"
              :demoType="propDemoType"
              :specialDemoCategory="specialDemoCategory"
              :key="item.ColumnName"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import notification from "@/components/common/notification";
import MDemoAllCheck from "@/components/demo/MDemoAllCheck";
import MDemoSelectItem from "@/components/demo/MDemoSelectItem";
import MDemoSelectType from "@/components/demo/MDemoSelectType";
export default {
  props: {
    propDemoType: {
      type: Number,
      default: 1,
    },
    specialDemoCategory: {
      type: [Number, Boolean],
      default: false,
    },
    needDemo: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    MDemoAllCheck,
    MDemoSelectItem,
    MDemoSelectType,
  },
  data() {
    return {
      categories: [
        {
          demoType: 18,
          desc: "Automotive",
        },
        {
          demoType: 16,
          desc: "Business",
        },
        {
          demoType: 15,
          desc: "Consumer Packaged Goods",
        },
        {
          demoType: 14,
          desc: "Communications",
        },
        {
          demoType: 19,
          desc: "Credit Card",
        },
        {
          demoType: 17,
          desc: "Financial Services",
        },
        {
          demoType: 3,
          desc: "General",
        },
        {
          demoType: 4,
          desc: "Health Care",
        },
        {
          demoType: 5,
          desc: "Insurance",
        },
        {
          demoType: 6,
          desc: "Investment Services",
        },
        {
          demoType: 7,
          desc: "Media",
        },
        {
          demoType: 8,
          desc: "Non-Profit",
        },
        {
          demoType: 9,
          desc: "Political",
        },
        {
          demoType: 10,
          desc: "Retail",
        },
        {
          demoType: 12,
          desc: "Travel Entertainment",
        },
        {
          demoType: 13,
          desc: "Technology",
        },
      ],
      hasLoad: true,
    };
  },
  computed: {
    listType() {
      if (this.$store.state.order.ListType) {
        return this.$store.state.order.ListType;
      } else {
        return 10;
      }
    },
    demos() {
      return this.$store.state.demo.demos;
    },
    columns() {
      if (
        this.listType in this.demos &&
        this.propDemoType in this.demos[this.listType]
      ) {
        return this.demos[this.listType][this.propDemoType];
      } else {
        this.getDemos(this.propDemoType);
        return [];
      }
    },
    isAllHoseholds() {
      return this.$store.getters["order/isAllHoseholds"];
    },
    isMobile () {
      return this.$store.state.config.isMobile
    }
  },
  created() {},
  methods: {
    getDemos() {
      this.hasLoad = false;
      this.$http
        .post("PlaceOrder.aspx/GetDemoAttributesList", {
          demotype: this.propDemoType,
          listtype: this.listType,
        })
        .then((resp) => {
          let data = resp.body.d.DataSource;
          this.$store.commit("demo/saveColumns", {
            listType: this.listType,
            demoType: this.propDemoType,
            data,
          });
          this.hasLoad = true;
        });
    },
  },
};
</script>

<style scoped lang="scss">
.h3-t {
  color: $color-black;
  margin-top: 8px;
}

.demos-column.demos-value {
  color: $color-black;
  margin-left: 0;
  /* TODO@PONY no unifrom css */
  font-size: 0.9em;
}

.demos-value {
  margin-left: 16px;
}

.select-demo-col {
  padding: 0 8px;
}

.box {
  padding-left: 8px;
  padding-right: 8px;
  display: block;
}

.input-box {
  display: block;
  width: 100%;
  height: 230px;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  color: #495057;
  background-color: $color-background;
  background-image: none;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}

.input-box-input {
  margin-top: -8px;
  margin-bottom: 8px;
}

.m-error-text {
  font-size: 12px;
  font-weight: normal;
}

.pc-right-select {
  text-align: right;
}

.pc-mt-title {
  margin-top: 0.9rem !important;
}

.item-btn {
  padding-right: 16px;
  padding-left: 16px;
  font-size: 0.9em;
}

.lable-name {
  margin-bottom: 0px;
}

.add-btn {
  margin: 8px;
}

.add-p {
  margin: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/demo/MDemoSelect.vue